const log = require('log').create('video') // eslint-disable-line

const NO_VIDEO_FOUND_ERROR = 'There doesn’t appear to be a publicly-available video at that link. Please try again.'
const UNABLE_TO_SAVE_ERROR = 'There was a problem saving your video. Please try again.'
const UNABLE_TO_REMOVE_ERROR = 'There was a problem removing your video. Please try again.'

const type_facebook = /facebook.com/i
const type_vimeo = /vimeo\.com\//i
const type_youtube = /youtube\.com|youtu\.be/i
const type_nfusz = /app\.nfusz\.com/i

function getVideoType(video_url) {
    if (type_facebook.test(video_url)) return 'facebook'
    if (type_vimeo.test(video_url)) return 'vimeo'
    if (type_youtube.test(video_url)) return 'youtube'
    if (type_nfusz.test(video_url)) return 'nfusz'
}

function getVideoInfo(url) {
    const $ = require('lib/jquery')
    const g = require('globals')
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'GET',
            url: `${g.NODE_API}/video/info`,
            data: {
                url,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .done((data) => {
                if (! data) return reject()
                if (! data.type) return reject()
                resolve(data)
            })
            .fail(reject)
    })
}

function isVideoType(type) {
    if (__DEBUG__) {
        if (typeof type !== 'string') throw new Error('type must be a string')
    }

    switch (type) {
        case 'facebook':
        case 'nfusz':
        case 'vimeo':
        case 'youtube':
            return true
        default:
            return false
    }
}

module.exports = {
    isVideoType,
    getVideoType,
    getVideoInfo,
    NO_VIDEO_FOUND_ERROR,
    UNABLE_TO_SAVE_ERROR,
    UNABLE_TO_REMOVE_ERROR,
}
